export default {
  description:
    'Ihre Änderungen und Ihre Projekte werden nur im Cache Ihres Browsers gespeichert. Das Löschen Ihrer Browserdaten führt zum Verlust Ihrer Projekte'
};
